<template>
  <v-app>
    <v-app-bar app elevate-on-scroll>
      <v-toolbar-title class="headline text-uppercase">
        <span>Moti</span>
        <span class="font-weight-light">plate</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn to='/food' text v-if="loggedIn">
        <span class="mr-2">Food</span>
      </v-btn>
      <v-divider
        inset
        vertical
      ></v-divider>
      <v-btn to='/login' text v-if="!loggedIn">
        <span class="mr-2" >Login</span>
      </v-btn>
      <v-btn text v-if="loggedIn" @click="logOut">
        <span class="mr-2" >Logout</span>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-snackbar
      v-model="showError"
      top
      color="error"
      :timeout="errorTimeout"
    >
      {{ error }}
      <v-btn
        text
        @click="dismissError"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data: () => ({
    showError: false,
    errorTimeout: 0
  }),
  computed: {
    user() {
      return this.$store.getter.user;
    },
    loggedIn() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    error() {
      return this.$store.getters.errorMessage
    },
  },
  watch: {
    loggedIn(value) {

    },
    error(value) {
      if (value !== null && value !== undefined) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('signOut');
      this.$router.push('/login')
    },
    dismissError() {
      this.$store.dispatch('dismissError');
    }
  }
}
</script>
<style>
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
